export default __webpack_public_path__ + "static/media/partner8.7b53e11c.webp";